'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import SkeletonLoadWrapper from '../loading/SkeletonLoadWrapper';

const SkeletonWrappedFormattedMessage = (_ref) => {
  let {
    translationsContext,
    message,
    MessageComponent = FormattedMessage,
    options = {},
    elements = {}
  } = _ref,
      skeletonProps = _objectWithoutPropertiesLoose(_ref, ["translationsContext", "message", "MessageComponent", "options", "elements"]);

  const {
    isReady
  } = useContext(translationsContext);
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, Object.assign({
    isLoading: !isReady
  }, skeletonProps, {
    children: /*#__PURE__*/_jsx(MessageComponent, {
      message: message,
      options: options,
      elements: elements
    })
  }));
};

SkeletonWrappedFormattedMessage.propTypes = {
  translationsContext: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  MessageComponent: PropTypes.elementType,
  options: PropTypes.object,
  elements: PropTypes.object
};
export default SkeletonWrappedFormattedMessage;